import { render, staticRenderFns } from "./major-group.vue?vue&type=template&id=5fa6642d&scoped=true"
import script from "./major-group.vue?vue&type=script&lang=js"
export * from "./major-group.vue?vue&type=script&lang=js"
import style0 from "./major-group.vue?vue&type=style&index=0&id=5fa6642d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6642d",
  null
  
)

export default component.exports